import { Component, OnInit, Input, Output, EventEmitter, ElementRef, OnDestroy } from '@angular/core';
// import { Calendar, EventInput } from '@fullcalendar/core';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import interactionPlugin from '@fullcalendar/interaction';
// import momentPlugin from '@fullcalendar/moment';
import esLocale from '@fullcalendar/core/locales/es';
import { SharedService } from '../../services/shared-service';
import { MatDialog } from '@angular/material/dialog';
import { CalanderFullService } from 'app/modules/Calander/services/calander-full.service';
import { Subscription } from 'rxjs';
import { Reservas } from '../../entities/reservas';
import { Address } from 'app/modules/agenda-view/entities/address';
import * as moment from 'moment';
import tippy from 'tippy.js';
import tinycolor from 'tinycolor2';
// import * as normal from 'tinycolor2';
import * as $ from 'jquery';
import { AddDownloadCalendarDialogParams, DownloadCalendarDialogComponent } from './download-calendar-dialog/download-calendar-dialog.component';
import { debug } from 'console';
import { EventInput } from '@fullcalendar/core';

declare const FullCalendar: any;

@Component({
  selector: 'app-scheduler-calendar',
  templateUrl: './scheduler-calendar.component.html',
  styleUrls: ['./scheduler-calendar.component.scss'],
  standalone: false
})
export class SchedulerCalendarComponent implements OnInit, OnDestroy {
  schedulerCalendar: any;
  @Input() DisableEventClick: boolean;
  @Input() DisableDayClick: boolean;
  @Input() Selectable: boolean;
  @Output() selectedCalendarInfo = new EventEmitter<{ start: moment.Moment, end: moment.Moment; }>();

  calanderData: any;
  subscription: Subscription;
  excludeList = [];
  noServiceTime: any = [];
  includeList = [];
  reserva: Reservas;
  serviceID: number;
  selectedDateTime: any;
  MinTime: any;
  MaxTime: any;
  today = new Date(moment().format('YYYY-MM-DD'));
  address: any;
  theHtmlString: any;
  position: any;
  tooltipAddress: any;
  comment: any;
  onleaveDate: any;
  onleaveDateList: any[] = [];
  showDownload = false;

  onSubsDate: any;
  onSubsDateList: any[] = [];

  onExtraDateList: any[] = [];
    onBlockedDateList: any[] = [];
  

  leaveFound: boolean = false;
  SubsFound: boolean = false;
  extraFound: boolean = false;
    blockedFound: boolean = false;
  

  
  constructor(private sharedService: SharedService, private dialog: MatDialog, private elem: ElementRef, private calanderfullservice: CalanderFullService) {
    }

    ngOnInit(): void {
        this.position = 'before';
        this.reserva = new Reservas();
        this.subscription = this.sharedService.getCalanderData().subscribe(
            (data: any) => {
                this.showDownload = false;
                if (data['text'].code === 0) {
                    this.calanderData = {};
                    this.calanderData = data['text'].result;

                    if (this.schedulerCalendar !== undefined) {
                        this.schedulerCalendar.removeAllEvents();
                        this.schedulerCalendar.destroy();
                    }
                    if (this.calanderData) {
                        if (this.calanderData.serviceList !== 0) {
                            this.address = this.calanderData.address;
                            this.DrawCalendar(this.calanderData);
                            this.calanderfullservice.isCalendarLoading = false;
                            this.showDownload = true;
                        } else {
                            this.calanderfullservice.isCalendarLoading = false;
                        }
                    }
                }
                else if (data['text'].code === 1) {
                    // clear calanderData when empty calanderData received
                    this.calanderData = {};
                    this.theHtmlString = '';
                    this.comment = null;
                    this.address = null;

                    if (this.schedulerCalendar !== undefined) {
                        this.schedulerCalendar.destroy();
                    }
                    this.calanderfullservice.isCalendarLoading = false;
                }

            });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private DrawCalendar(calData: any): void {
        moment.locale('es');

        this.onleaveDateList=[];
        this.leaveFound=false;
        this.onExtraDateList=[];
        this.onBlockedDateList=[];
        this.blockedFound=false;
        this.onSubsDateList=[];
        this.SubsFound=false;
        this.extraFound=false;

        if (calData) {
            this.excludeList = calData.excludeList;
            this.noServiceTime = calData.noServiceTime;
            this.includeList = calData.serviceList;
        }
        if (calData.address) {
            const addr = calData.address;
            if (!calData.address.empresa) {
                this.theHtmlString = calData.address.medicoreferencia;
            } else if (!calData.address.medicoreferencia) {
                this.theHtmlString = calData.address.empresa;
            } else if (!calData.address.empresa && !calData.address.medicoreferencia) {
                this.theHtmlString = '';
            } else {
                this.theHtmlString = calData.address.empresa + ' - ' + calData.address.medicoreferencia;
            }
            let arr = [addr.nombrecentro, addr.direccion, addr.cp, addr.poblacion, addr.telefono];
            arr = arr.filter(e => e);
            this.tooltipAddress = arr.join('\n');
        }

        if (calData.comment) {
            this.comment = calData.comment;
        }
        const start = this.includeList[0];
        const end = moment(this.includeList[this.includeList.length - 1]).add(1, 'd').format('YYYY-MM-DDTHH:mm:ss');
        let availableslots = this.noServiceTime.filter((obj) => obj.id === 'availableSlots');
        if (availableslots.length > 0) {
            this.findMaxandMinTime(availableslots);
        }else{
            availableslots = this.noServiceTime.filter((obj) => obj.id === 'unavailableSlot');
            this.findMaxandMinTime(availableslots);
        }
        
        const timeRangesByDay: Record<number, Array<{ start: string; end: string }>> = {};
        availableslots.forEach(slot => {
            const day = moment(slot.start).isoWeekday();
            const start = moment(slot.start).format('HH:mm:ss');
            const end = moment(slot.end).format('HH:mm:ss');

            if (!timeRangesByDay[day]) {
                timeRangesByDay[day] = [];
            }

            timeRangesByDay[day].push({ start, end });
        });

        this.noServiceTime = this.noServiceTime.filter(event => {
            const eventStart = moment(event.start);
            const eventEnd = event.end ? moment(event.end) : moment(event.start);
            const day = eventStart.isoWeekday();
            const dayRanges = timeRangesByDay[day];

            if (!dayRanges || !eventStart.isValid() || !eventEnd.isValid()) {
                return false;
            }

            const eventStartTime = eventStart.format('HH:mm:ss');
            const eventEndTime = eventEnd.format('HH:mm:ss');

            return dayRanges.some(range =>
                eventStartTime < range.end && eventEndTime > range.start
            );
        });

        const self = this;
        if(this.calanderData.noServiceTime.length>0 && start !=undefined)
        {
            this.schedulerCalendar = new FullCalendar.Calendar(document.getElementById('scheduler-calendar'), {
                plugins: ['timeGrid','interaction','moment'],
                header: false,
                locale: 'es',
                displayEventTime: false,
                firstDay: 1,
                monthNames: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre" ], 
                monthNamesShort: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
                dayNames: [ 'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                dayNamesShort: ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
                buttonText: {
                    today: 'hoy',
                    month: 'mes',
                    week: 'semana',
                    day: 'día'
                },
                slotLabelInterval:'00:15:00',
                allDaySlot: true,
                // allDayText:'Todo el dia',
                columnHeaderFormat: 'dddd D/M',
                weekends: false,
                defaultView: 'agendaFourDay',
                views: {
                    agendaFourDay: {
                        type: 'timeGrid'
                    }
                },
                slotDuration: '00:15:00', /* If we want to split day time each 15minutes */
                slotLabelFormat: 'HH:mm',
                minTime: this.MinTime,
                maxTime: this.MaxTime,
                visibleRange: {
                    start: start,
                    end: end,
                },
                eventOverlap: true,
                slotEventOverlap: true,
                selectable: self.Selectable,
                eventLimit: true,
                selectOverlap: true,
                events: this.noServiceTime,
                contentHeight: 'auto',
                
    
                viewSkeletonRender: (info) => {
                    this.hideDates(this.excludeList);
                },
                eventRender: (info) => {
                    const event = info.event;
                    const date = moment(event.start).format('YYYY-MM-DD');
                    if (event.title === 'onLeave') {
                       
                        if(this.onleaveDateList.length>0)
                        {
                            //Check leave is displayed
                            this.onleaveDateList.forEach(element => {
                                if(element==date)
                                {
                                    this.leaveFound=true;
                                }
                            });
    
                            if(!this.leaveFound)
                            {
                                self.renderTooltip(date, event);
                                this.onleaveDateList.push(date);
                            }  
                        }else
                        {
                            self.renderTooltip(date, event);
                            this.onleaveDateList.push(date);
                        }
    
                    }else if (event.title === 'extra') {
                        if(this.onExtraDateList.length>0)
                        {
                            //Check leave is displayed
                            this.onExtraDateList.forEach(element => {
                                if(element==date)
                                {
                                    this.extraFound=true;
                                }
                            });
    
                            if(!this.extraFound)
                            {
                                self.renderTooltip(date, event);
                                this.onExtraDateList.push(date);
                            }  
                        }else
                        {
                            self.renderTooltip(date, event);
                            this.onExtraDateList.push(date);
                        }
                        
    
                    }else if (event.title === 'blocked') {
                        if(this.onBlockedDateList.length>0)
                        {
                            //Check leave is displayed
                            this.onBlockedDateList.forEach(element => {
                                if(element==date)
                                {
                                    this.blockedFound=true;
                                }
                            });
    
                            if(!this.blockedFound)
                            {
                                self.renderTooltip(date, event);
                                this.onBlockedDateList.push(date);
                            }  
                        }else
                        {
                            self.renderTooltip(date, event);
                            this.onBlockedDateList.push(date);
                        }
                    }
                    
                     else if (event.title === 'Substitute') {
    
                        if(this.onSubsDateList.length>0)
                        {
                            //Check leave is displayed
                            this.onSubsDateList.forEach(element => {
                                if(element==date)
                                {
                                    this.SubsFound=true;
                                }
                            });
    
                            if(!this.SubsFound)
                            {
                                self.renderTooltip(date, event);
                                this.onSubsDateList.push(date);
                            }  
                        }else
                        {
                            self.renderTooltip(date, event);
                            this.onSubsDateList.push(date);
                        }
    
                        //self.renderTooltip(date, event);
    
                    } else if (event.title === 'isHoliday') {
                        self.renderTooltip(date, event);
    
                    }
                },
                eventPositioned: (view) => {
                    tippy('.subst', {
                    });
                    tippy('.leavehd', {
                    });
                    tippy('.holidayCs', {
                    })
                    tippy('.blockedHours', {
                    });
                },
                eventClick: (info) => {
                    const event = info.event;
                    if (!self.DisableEventClick) {
                        // Show in red
                        if (event.id === 'appointments') {
                            self.openDialog(event);
                        } else if (event.id === 'Occupido') {
                            return;
                        }
                    }
                },
                eventMouseEnter: (info) => {
                    const event = info.event
                    if (event.id === 'Occupido') {                        
                        tippy(info.el, {
                            content: `<div style="background-color: #3B3E4E; color: #fff; padding: 3px 5px; font-size: 0.75em; margin-bottom: -7px; border-radius: 3px;">${event.title}</div>`,
                            allowHTML: true,
                            delay: 0,
                        });
                    }
                },
                dateClick: (info) => {
                    const eventStart = moment(info.dateStr);
                    const jsEvent = info.jsEvent as EventInput;
    
                    if (!self.DisableDayClick) {
                        this.selectedDateTime = eventStart.format();
                        if (jsEvent.target.classList.contains('pointer_Cursor')) {
                            self.setStartEndTimes(eventStart.format());
                        }
                    }
                },
                eventDrop: (info) => {
                    // const calEvent = info.event;
                    // const strtTime = moment(calEvent.start).format('HH:mm');
                    // const endTime = moment(calEvent.end).format('HH:mm');
                },
                select: (info) => {
                    const startDate = moment(info.start);
                    const endDate = moment(info.end);
                    if (self.Selectable) {
                        self.selectedCalendarInfo.emit({ start: startDate, end: endDate });
                    }


                    var timeOri = moment(info.start, "dd-MM-yyy hh:mm:ss A")
                                .format('LTS');

                    var timeAdd15 = moment(info.start, "dd-MM-yyy hh:mm:ss A")
                                .add(15, 'minutes')
                                .format('LTS');

                    var timeend = moment(info.end, "dd-MM-yyy hh:mm:ss A")
                                .format('LTS');

                                if(timeAdd15!=timeend)
                                {
                                    this.schedulerCalendar.unselect()
                                }           
                }
            });

            this.schedulerCalendar.render();
        }else
        {
            this.schedulerCalendar = new FullCalendar.Calendar(document.getElementById('scheduler-calendar'), {
                plugins: ['timeGrid','interaction','moment'],
                header: false,
                displayEventTime: false,
                allDaySlot: false,
                weekends: false,
                defaultView: 'agendaFourDay',
                views: {
                    agendaFourDay: {
                        type: 'timeGrid'
                    }
                },
                visibleRange: {
                    start: start,
                    end: end,
                },
                eventOverlap: true,
                slotEventOverlap: true,
                selectable: self.Selectable,
                eventLimit: true,
                selectOverlap: true,
                events: this.noServiceTime,
                contentHeight: 'auto',
    
                viewSkeletonRender: (info) => {
                    this.hideDates(this.excludeList);
                },
            });

            this.schedulerCalendar.render();
        }
    }

    hideDates(dateList: any[]): void {
        dateList.forEach(dateItem => {
            let position = 1;
            const rowDate = new Date(dateItem);
            const date = moment(rowDate).format('YYYY-MM-DD');
            // calculate position
            const elements = $('div.fc-view-container>div.fc-agendaFourDay-view>table>thead.fc-head>tr>td.fc-head-container>div.fc-widget-header>table>thead>tr>th');
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].getAttribute('data-date') === date) {
                    break;
                }
                position++;
            }
            // Hide date headers
            $('[data-date="' + date + '"]').hide();
            $('div.fc-bg>table>tbody>tr>td[data-date="' + date + '"]').hide();
            $('div.fc-content-skeleton>table>tbody>tr>td:nth-child(' + position + ')').hide();
        });

        // set the table size according to include list
        let tableSize = null;
        if (this.includeList.length <= 6) {
            tableSize = (this.includeList.length) * 180;
        }
        else {
            tableSize = (this.includeList.length) * 140;
        }

        (document.querySelector('div.fc-view-container>div.fc-agendaFourDay-view>table') as HTMLElement).style.width = tableSize + 'px';
    }

    openCalendarDialog() {
          console.log('selectedNode', this.calanderfullservice.selectedNode);

        const data: AddDownloadCalendarDialogParams = {
            medico: this.address.medicoreferencia, 
            smeId : this.calanderfullservice.selectedNode.serviceId,
            medicoId : this.calanderfullservice.selectedNode.medicoId,
            empresaId : this.calanderfullservice.selectedNode.empresaId,
            smeNombre : this.calanderfullservice.selectedNode.text,
            medicoPrincipalId : this.calanderfullservice.selectedNode.medicoPrincipalId
        };
         console.log('dialog data', data);

        const dialog = this.dialog.open(DownloadCalendarDialogComponent, {
            width: '400px',
            data,
        });
    }

    openDialog(event): void {
        this.reserva.Smeid = this.noServiceTime[0].serviceId;
        this.reserva.Finicio = moment(event.start).toDate();
        this.reserva.Ffin = moment(event.end).toDate();
        this.reserva.ReservaId = event.extendedProps.reservaId;
        this.reserva.TipoEvento = 0;
        this.reserva.Opciones = 2;
        this.reserva.Caption = '';
        this.calanderfullservice.saveRemoveAppointment(this.reserva).subscribe(
            (data: any) => {
                if (data.code === 0) {
                    this.reDrawCalenderCall();
                }
            });
    }

    openDialog1(startDate, endDate, serID): void {
        this.reserva.Smeid = this.noServiceTime[0].serviceId;
        this.reserva.Finicio = startDate;
        this.reserva.Ffin = endDate;
        this.reserva.ReservaId = 0;
        this.reserva.TipoEvento = 0;
        this.reserva.Opciones = 2;
        this.reserva.Caption = '';
        this.calanderfullservice.saveRemoveAppointment(this.reserva).subscribe(
            (data: any) => {
                if (data.code === 0) {
                    this.reDrawCalenderCall();
                }
            });
    }

    setStartEndTimes(start): void {
        const startDate = moment(start).format('YYYY-MM-DDTHH:mm:ss');
        const endDate = moment(start).add(15, 'm').format('YYYY-MM-DDTHH:mm:ss');
        this.openDialog1(startDate, endDate, this.serviceID);
    }

    findMaxandMinTime(availableslots): void {
        if (availableslots.length > 0) {
            this.MinTime = moment(availableslots[0].start).format('HH:mm:ss');
            this.MaxTime = moment(availableslots[0].end).format('HH:mm:ss');
        }

        for (let i = 0; i < availableslots.length; i++) {
            if (moment(availableslots[i].start).format('HH:mm:ss') < this.MinTime) {
                this.MinTime = moment(availableslots[i].start).format('HH:mm:ss');
            }
            if (moment(availableslots[i].end).format('HH:mm:ss') > this.MaxTime) {
                this.MaxTime = moment(availableslots[i].end).format('HH:mm:ss');
            }
        }

    }

    reDrawCalenderCall(): void {
        this.calanderfullservice.getCalendarForNextTwoMonths().subscribe(
            (data: any) => {
                if (data.code === 0) {
                    this.calanderData = data.result;
                    if (this.schedulerCalendar !== undefined) {
                        this.schedulerCalendar.destroy();
                    }
                    this.calanderfullservice.isCalendarLoading = false;                  
                    this.DrawCalendar(this.calanderData);
                } else if (data.code === 1) {
                    this.calanderData = {};
                    if (this.schedulerCalendar !== undefined) {
                        this.schedulerCalendar.destroy();
                    }
                }
            }
        );
    }

    renderTooltip(date, event): void {
        const transBackground = { r: 255, g: 255, b: 255, a: 1 };
        const bendColor = tinycolor(transBackground, event.color);
        const bendColorString = tinycolor(bendColor).toRgbString();
        const elements = $('div.fc-view-container>div.fc-agendaFourDay-view>table>thead.fc-head>tr>td.fc-head-container>div.fc-widget-header>table>thead>tr>th');
        
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].getAttribute('data-date') === date && event._def.extendedProps.description) {
                const button = document.createElement('i');
                button.classList.add('material-icons', 'info');
                button.innerText = 'info';
                elements[i].appendChild(button);
                if (event.title === 'onLeave') {
                    button.classList.add('leavehd');
                } else if (event.title === 'Substitute') {
                    button.classList.add('subst');
                }else if (event.title === 'extra') {
                    button.classList.add('subst')
                } else if (event.title === 'isHoliday') {
                    button.classList.add('holidayCs');
                } else if (event.title === 'blocked') {
                    button.classList.add('blockedHours');
                }
                tippy(button, {
                    content: `<div style="background-color:transparent;color:${event.textColor};font-weight:bold;border:1px solid black;background:white;border-radius:3px;padding:5px" class="event-expanded"> <div class="rowline p-t-3">${event._def.extendedProps.description}</div></div>`,
                    allowHTML: true,
                    placement: 'bottom',
                    theme: 'light',
                });  
            }
        }
    }

}
